import { PluginKey } from "@tiptap/pm/state";
import { VARIABLE_MENTION_TOKEN_ATTRIBUTE } from "../variable-mention/variable-mention.constants";

export { TEMPLATE_TOKEN_KIND } from "../variable-token/variable-token.constants";

/**
 * The ProseMirror node name for an Ask Spotlight template chip. Referenced by Tiptap's command and schema type maps as
 * well as by the extension itself, so it is a constant rather than a repeated string literal.
 */
export const TEMPLATE_MENTION_NODE_NAME = "templateMention";

/** The character that opens the template suggestion. */
export const TEMPLATE_MENTION_SUGGESTION_CHAR = "/";

/**
 * The suggestion plugin's own key. Tiptap's `Suggestion` defaults to one shared key, which would collide with the
 * variable pill's `@` suggestion on the same editor.
 */
export const TEMPLATE_MENTION_SUGGESTION_PLUGIN_KEY = new PluginKey("templateMentionSuggestion");

/**
 * The marker attribute identifying a template chip's `<span>` in serialised HTML. Present but empty: it exists so
 * `parseHTML` (and the composer's markdown conversion) can match the element. The token itself goes in `data-token`,
 * the same attribute a variable pill uses.
 */
export const TEMPLATE_MENTION_DATA_ATTRIBUTE = "data-template-mention";

/** The attribute carrying the serialised template token, the same one a variable pill's HTML uses. */
export const TEMPLATE_MENTION_TOKEN_ATTRIBUTE = VARIABLE_MENTION_TOKEN_ATTRIBUTE;

/** The token's value key: the template's id, named as the API names it. */
export const TEMPLATE_TOKEN_VALUE_KEY = "aiChatReportTemplateId";

/** The token's title. Every template token has the same one; the label carries the command. */
export const TEMPLATE_TOKEN_TITLE = "Template";

/** What a template's command is typed and shown after. The token stores the command without it. */
export const TEMPLATE_COMMAND_PREFIX = "/";

/**
 * A template's prompt as the agent may attach it to a user message: `[template-body-start:<id>]…[template-body-end]`.
 * The chip is what a message shows, so the body is hidden wherever a user message is drawn. Non-greedy and global, so
 * each block ends at its own end marker. Only consume it through `replace`, never `.exec()` or `.test()`.
 */
export const TEMPLATE_BODY_REGEX = /\[template-body-start:[^\]]*\][\s\S]*?\[template-body-end\]/g;
